import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import Styles from './MapWidget.styles';

class MapWidget extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.iconOnMouseOver = this.iconOnMouseOver.bind(this);
    this.iconOnMouseOut = this.iconOnMouseOut.bind(this);
    this.borderOnMouseOver = this.borderOnMouseOver.bind(this);
    this.borderOnMouseOut = this.borderOnMouseOut.bind(this);
    this.borderOnMouseMove = this.borderOnMouseMove.bind(this);
    this.onMouseDrop = this.onMouseDrop.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.grabbed = false;
    this.state = {
      icon: props.isMain ? 'icon-home' : '',
      borderActive: false,
      borderConnectorIconPosition: {},
      showSpread: false,
    };
  }

  componentDidMount() {
    if (this.props.selected) {
      this.widget.focus();
    }
  }

  componentWillReceiveProps(newProps) {
    const { isMain } = newProps;
    if (!this.grabbed) {
      this.setState({ icon: isMain ? 'icon-home' : '', showSpread: false, borderActive: false });
    }
  }

  componentDidUpdate() {
    if (this.props.selected) {
      this.widget.focus();
    }
  }

  onKeyDown(event) {
    this.props.onKeyDown(event);
  }

  onMouseDown(event) {
    event.nativeEvent.preventDefault();
    if (event.nativeEvent.target === this.icon) {
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp);
      this.grabX = event.nativeEvent.screenX;
      this.grabY = event.nativeEvent.screenY;
      this.grabLeft = this.widget.offsetLeft;
      this.grabTop = this.widget.offsetTop;
      this.parentWidth = this.widget.parentElement.offsetWidth;
      this.parentHeight = this.widget.parentElement.offsetHeight;
      this.grabbed = true;
      this.setState({
        icon: 'icon-crosshair-2',
        showSpread: false,
        borderActive: false,
      });
      const { onSelect } = this.props;
      if (this.props.onSelect) {
        onSelect(this.props.id);
      }
    } else if (this.border.contains(event.target)) {
      const { onStartConnect } = this.props;
      if (this.props.onStartConnect) {
        onStartConnect(this.props.object);
      }
    }
  }

  onMouseMove(event) {
    event.preventDefault();
    let positionX = (this.grabLeft + (event.screenX - this.grabX)) / this.parentWidth;
    let positionY = (this.grabTop + (event.screenY - this.grabY)) / this.parentHeight;
    positionX = Math.min(Math.max(positionX, 0), 1);
    positionY = Math.min(Math.max(positionY, 0), 1);
    this.props.object.positionX = positionX;
    this.props.object.positionY = positionY;

    const { onChangePosition } = this.props;
    if (this.props.onChangePosition) {
      onChangePosition(this.props.object, event);
    }
  }

  onMouseUp(event) {
    event.preventDefault();
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('mouseup', this.onMouseUp);
    this.grabbed = false;
    const { onMouseUp } = this.props;
    if (onMouseUp) {
      onMouseUp(this.props.object);
    }
    if (event.target === this.icon) {
      this.setState({
        icon: 'icon-hand',
        showSpread: true,
        borderActive: false,
      });
    } else if (event.target === this.border) {
      this.setState({
        icon: 'icon-crosshair-2',
        showSpread: false,
        borderActive: false,
      });
    } else {
      this.setState({
        icon: this.props.isMain ? 'icon-home' : '',
        showSpread: false,
        borderActive: false,
      });
    }
  }

  onMouseDrop(event) {
    event.nativeEvent.preventDefault();
    const { onMouseDrop } = this.props;
    if (this.props.onMouseDrop) {
      onMouseDrop(this.props.object);
    }
  }

  iconOnMouseOver(event) {
    event.preventDefault();
    if (this.props.selected && !this.grabbed) {
      this.setState({
        icon: 'icon-hand',
        borderActive: false,
        showSpread: true,
      });
    }
  }

  iconOnMouseOut(event) {
    event.preventDefault();
    if (!this.grabbed) {
      this.setState({
        icon: this.props.isMain ? 'icon-home' : '',
        showSpread: false,
        borderActive: false,
      });
    }
  }

  borderOnMouseMove(event) {
    if (this.props.selected && !this.grabbed) {
      const box = this.border.getBoundingClientRect();
      const dx = event.clientX - box.left - box.width * 0.5;
      const dy = event.clientY - box.top - box.height * 0.5;
      const angle = Math.atan2(dy, dx);
      const posX = box.width / 2 + 20 * Math.cos(angle);
      const posY = box.height / 2 + 20 * Math.sin(angle);
      const position = { left: posX, top: posY };
      const angleDegree = angle * 180 / Math.PI;
      this.setState({
        icon: 'icon-chain-2',
        borderConnectorIconPosition: position,
        borderConnectorIconAngle: angleDegree,
        borderActive: true,
        showSpread: false,
      });
    }
  }

  borderOnMouseOver(event) {
    event.preventDefault();
    if (this.props.selected && !this.grabbed) {
      const box = this.border.getBoundingClientRect();
      const dx = event.clientX - box.left - box.width * 0.5;
      const dy = event.clientY - box.top - box.height * 0.5;
      const angle = Math.atan2(dy, dx);
      const posX = box.width / 2 + 20 * Math.cos(angle);
      const posY = box.height / 2 + 20 * Math.sin(angle);
      const position = { left: posX, top: posY };
      const angleDegree = angle * 180 / Math.PI;
      this.setState({
        icon: 'icon-chain-2',
        borderConnectorIconPosition: position,
        borderConnectorIconAngle: angleDegree,
        borderActive: true,
        showSpread: false,
      });
    }
  }

  borderOnMouseOut(event) {
    event.preventDefault();
    if (!this.grabbed) {
      this.setState({
        icon: this.props.isMain ? 'icon-home' : '',
        borderActive: false,
        showSpread: false,
      });
    }
  }

  render() {
    const { selected, highlighted, isMain } = this.props;

    const selectedStyle = selected ? Styles.borderStyleSelected : {};
    let selectedIconStyle = {};
    if (selected) {
      selectedIconStyle = this.grabbed ? Styles.iconStyleGrabbed : Styles.iconStyleSelected;
    }

    const highlightedStyle = highlighted ? Styles.iconStyleHighlighted : {};
    const mainIconStyle = isMain ? Styles.mainIconStyle : {};
    const connectorPointStyle = this.state.borderActive
      ? Styles.connectorPointStyle(
          this.state.borderConnectorIconPosition.top,
          this.state.borderConnectorIconPosition.left,
        )
      : { display: 'none' };
    return (
      <div
        className="MapWidget"
        tabIndex="0"
        role="button"
        style={Styles.widgetStyle(this.props.positionX, this.props.positionY)}
        ref={(widget) => {
          this.widget = widget;
        }}
        onMouseDown={this.onMouseDown}
        onMouseUp={this.onMouseDrop}
        onKeyDown={this.onKeyDown}
        onKeyPress={this.onKeyDown}
        onKeyUp={this.onKeyDown}
      >
        <div style={Styles.iconWrapper}>
          <div
            className="WidgetBorder"
            style={[Styles.borderStyle, selectedStyle]}
            ref={(border) => {
              this.border = border;
            }}
            onMouseOver={this.borderOnMouseOver}
            onMouseOut={this.borderOnMouseOut}
            onMouseMove={this.borderOnMouseMove}
          >
            <div style={connectorPointStyle}>
              <span
                ref={(borderIcon) => {
                  this.borderIcon = borderIcon;
                }}
                className={'icon-arrow-right'}
                style={{
                  fontSize: '6px',
                  transform: `translate(-50%,-50%) rotate(${
                    this.state.borderConnectorIconAngle
                  }deg)`,
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                }}
              />
            </div>
          </div>
          <div
            className="WidgetIcon"
            style={[Styles.iconStyle, selectedIconStyle, highlightedStyle, mainIconStyle]}
            ref={(icon) => {
              this.icon = icon;
            }}
            onMouseOver={this.iconOnMouseOver}
            onMouseOut={this.iconOnMouseOut}
          >
            {' '}
            <span
              className={this.state.icon}
              style={this.grabbed ? Styles.spanStyleGrabbed : Styles.spanStyle}
            />
          </div>
          {this.state.showSpread && <span className={'icon-spread'} style={Styles.spreadIcon} />}
        </div>
      </div>
    );
  }
}
MapWidget.defaultProps = {
  selected: false,
};
MapWidget.propTypes = {
  selected: PropTypes.bool,
  positionX: PropTypes.number.isRequired,
  positionY: PropTypes.number.isRequired,
};

export default Radium(MapWidget);



// WEBPACK FOOTER //
// ./src/components/Map/MapWidget/MapWidget.js